// extracted by mini-css-extract-plugin
module.exports = {"base":"shared-layout_base__YMljb"};